import React, { useState, useEffect } from "react";
import {
  CheckOutlined,
  ExclamationCircleFilled,
  LeftOutlined,
  RightOutlined,
  EditOutlined,
  CalendarOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

//outsource
import moment from "moment";
import {
  Row,
  Col,
  Button,
  Space,
  Form,
  Modal,
  Tag,
  Tooltip,
  message,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setDate } from "../../../store/var/var.action";
import { addCashUp } from "../../../store/cashup/cashup.action";
import { setDateLabel } from "../../../store/var/var.action";
import { dateSelector } from "../../../store/var/var.selector";
import { labelDateSelector } from "../../../store/var/var.selector";
import { detailBranchSelector } from "../../../store/branch/branch.selector";
import { STATUS_CASHUP } from "../../../store/string";
import DialogDateSelect from "../dialog/dialog_date_select";
import numeral from "numeral";
import { addIncomeByStaff } from "../../../store/income/income.action";
import { mediaSelector } from "../../../store/media/media.selector";
//components

const { confirm } = Modal;

const CashupTop = (props) => {
  // -------------------------- VAR --------------------------
  const {
    edit,
    block,
    differ,
    status,
    totalReceive,
    totalNotes,
    totalRedeem,
    totalDiscount,
    totalStaffs,
    totalIncomeStaff,
    totalIncomeReceive,
    totalVoucher,
    totalVoucherRedeem,
    setEdit,
    setBlock,
    resetAllFields,
    incomes,
    lockedBy,
    //
    disabled,
  } = props;
  const form = Form?.useFormInstance();
  // -------------------------- STATE --------------------------
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const date = useSelector(dateSelector);
  const label = useSelector(labelDateSelector);
  const branch = useSelector(detailBranchSelector);
  // -------------------------- FUNCTION -----------------------
  const openDialog = () => {
    setOpen(true);
  };

  const handleNextDate = () => {
    let target = date || moment();
    const next = target?.add(1, "day");
    dispatch(setDate({ data: next }));
    dispatch(setDateLabel({ data: next?.format("DD/MM/YYYY") }));
  };

  const handlepreviousDate = () => {
    let target = date || moment();
    const prev = target?.subtract(1, "day");
    dispatch(setDate({ data: prev }));
    dispatch(setDateLabel({ data: prev?.format("DD/MM/YYYY") }));
  };

  const handleConfirm = () => {
    if (differ >= 100) {
      showConfirm();
    } else {
      confirmCashup();
    }
  };

  const showConfirm = () => {
    confirm({
      title: "Difference greater than $100",
      icon: <ExclamationCircleFilled />,
      content: "Do you want to continue confirming the cashup?",
      okText: "Confirm",
      onOk() {
        addRecord("confirmed");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const confirmCashup = () => {
    confirm({
      title: "Confirm the cashup",
      icon: <ExclamationCircleFilled />,
      content: "Do you want to continue confirming the cashup?",
      okText: "Confirm",
      onOk() {
        addRecord("confirmed");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const addRecord = (status) => {
    if (label && branch) {
      setLoading(true);
      const values = form?.getFieldsValue();
      console.log({ values });
      const cash = values?.cash;
      const eftpos = values?.eftpos;
      const gift = values?.gift;
      const evidences = values?.evidences || [];
      const bankTransfer = values?.bankTransfer;

      const data = {
        date: label,
        branch: branch?.id || "",
        owner: branch?.owner || "",
        name: branch?.name || "",
        evidences: evidences,
        status: status,
        totalReceive,
        totalNotes,
        totalRedeem,
        totalDiscount,
        totalStaffs,
        totalVoucher,
        totalVoucherRedeem,
        cash,
        eftpos,
        gift,
        bankTransfer,
        totalIncomeStaff,
        totalIncomeReceive,

        lockedBy: lockedBy ? lockedBy : "Owner",
      };

      dispatch(
        addCashUp({ data }, (res) => {
          setLoading(false);
          if (res.status === 200) {
            message.success("Confirmed Successfully!");
            resetAllFields();
          } else {
            message.error(res?.data);
          }
        })
      );

      // record incomeStaff collection
      dispatch(
        addIncomeByStaff({ data: incomes }, (res) => {
          if (res.status === 200) {
            //
          } else {
            //
          }
        })
      );
    }
  };

  const changeStatus = (status) => {
    if (label && branch) {
      setLoading(true);
      const values = form?.getFieldsValue();
      const cash = values?.cash;
      const eftpos = values?.eftpos;
      const gift = values?.gift;
      const evidences = values?.evidences || [];
      const bankTransfer = values?.bankTransfer;

      const data = {
        date: label,
        branch: branch?.id || "",
        owner: branch?.owner || "",
        name: branch?.name || "",
        evidences,
        status: status,
        totalReceive,
        totalNotes,
        totalRedeem,
        totalDiscount,
        totalStaffs,
        totalVoucher,
        totalVoucherRedeem,
        cash,
        eftpos,
        gift,
        bankTransfer,
        totalIncomeStaff,
        totalIncomeReceive,
      };

      dispatch(
        addCashUp({ data }, (res) => {
          setLoading(false);
          if (res.status === 200) {
          } else {
            message.error(res?.data);
          }
        })
      );
    }
  };

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const renderControlDate = () => {
    return (
      <Space>
        {renderLeft()}
        {renderButton()}
        {renderRight()}
      </Space>
    );
  };

  const renderLeft = () => {
    return (
      <Tooltip title="previous Date">
        <Button
          onClick={handlepreviousDate}
          type="text"
          icon={<LeftOutlined />}
        />
      </Tooltip>
    );
  };

  const renderRight = () => {
    const disabled =
      date?.format("DD/MM/YYYY") === moment()?.format("DD/MM/YYYY")
        ? true
        : false;

    return (
      <Tooltip title="Next Date">
        <Button
          disabled={disabled}
          onClick={handleNextDate}
          type="text"
          icon={<RightOutlined />}
        />
      </Tooltip>
    );
  };

  const renderButton = () => {
    return (
      <Button
        onClick={openDialog}
        icon={<CalendarOutlined style={{ color: "gray" }} />}
      >
        {label}
      </Button>
    );
  };

  const renderEditButton = () => {
    if (!edit || block) {
      return (
        <Button
          onClick={() => {
            setEdit(true);
            setBlock(false);
            if (status) {
              changeStatus("unconfirmed");
            }
          }}
          className="done-btn"
          icon={<EditOutlined />}
          type="primary"
          style={{ marginLeft: 10 }}
          disabled={loading || disabled}
          loading={loading || disabled}
        >
          Edit
        </Button>
      );
    }
    return null;
  };

  const renderConfirmBtn = () => {
    if (status === "unconfirmed" || !status) {
      const icon =
        differ >= 100 ? <ExclamationCircleOutlined /> : <CheckOutlined />;
      return (
        <Button
          onClick={handleConfirm}
          icon={icon}
          type="primary"
          disabled={loading || disabled}
          loading={loading || disabled}
          style={
            loading || disabled
              ? null
              : { backgroundColor: "green", borderColor: "green" }
          }
        >
          Confirm
        </Button>
      );
    }
    return null;
  };

  const renderDialog = () => {
    return <DialogDateSelect open={open} setOpen={setOpen} />;
  };

  const renderStatus = () => {
    const label = STATUS_CASHUP?.find((item) => item?.value === status)?.label;
    let color = differ > 100 ? "red" : differ > 0 ? "orange" : "green";
    return (
      <Space size="small">
        <Tag color={color}>Difference: ${numeral(differ).format("0.00")} </Tag>
        {lockedBy ? <Tag color="blue">Cashed up: {lockedBy}</Tag> : null}
        {status === "confirmed" ? <Tag color={"#87d068"}>{label}</Tag> : null}
      </Space>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row style={{ width: "100%" }} align="middle">
      <Col span={8}>{renderStatus()}</Col>
      <Col align="center" span={8}>
        {renderControlDate()}
      </Col>
      <Col align="right" span={8}>
        {renderConfirmBtn()}
        {renderEditButton()}
      </Col>
      {renderDialog()}
    </Row>
  );
};

export default CashupTop;
